import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { BaseSubsectionAdapter } from '../../../adapters/BaseSubsectionAdapter'
import { RecertFormData } from '../../types/RecertFormData'
import { RecertFormField } from '../../types/RecertFormField'
import { RecertAssessmentQuestionnaireItem } from '../../types/questionnaire'

export class FinalStepsAdapter extends BaseSubsectionAdapter<RecertFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RecertFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    const finalStepsInternalNotes = getAnswerValuesFromItems(
      flatAnswersArray,
      RecertAssessmentQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES
    )?.at(0)
    const pendingRequiredDocumentation =
      getAnswerValuesFromItems(
        flatAnswersArray,
        RecertAssessmentQuestionnaireItem.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION
      ) || []

    return {
      [RecertFormField.INTERNAL_NOTES]: finalStepsInternalNotes,
      [RecertFormField.PENDING_REQUIRED_DOCUMENTATION]: pendingRequiredDocumentation
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(RecertFormField.INTERNAL_NOTES)) {
      mutations.push({
        linkId: RecertAssessmentQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES,
        value: this.getFormDataField(RecertFormField.INTERNAL_NOTES)
      })
    }

    if (this.formDataFieldExists(RecertFormField.PENDING_REQUIRED_DOCUMENTATION)) {
      mutations.push({
        linkId: RecertAssessmentQuestionnaireItem.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION,
        value: this.getFormDataField(RecertFormField.PENDING_REQUIRED_DOCUMENTATION)
      })
    }

    return mutations
  }
}
